import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const bccolumn = [
  {
    field: "thang",
    headerName: "Tháng báo cáo",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "sootocon",
    headerName: "Tổng số ô tô con",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "sootocon_dkkd",
    headerName: "Số ô tô con ĐKKD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sootodien",
    headerName: "Tổng số ô tô điện",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "sootodien_dkkd",
    headerName: "Số ô tô điện ĐKKD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "sootokhach",
    headerName: "Tổng số ô tô khách",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "sootokhach_dkkd",
    headerName: "Số ô tô khách ĐKKD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "soototai",
    headerName: "Tổng số ô tô tải",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "soototai_dkkd",
    headerName: "Số ô tô tải ĐKKD",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "soxemay_dkkd",
    headerName: "Số xe máy",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "ghichu_baocao",
    headerName: "Ghi chú",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngaycn",
    headerName: "Ngày cập nhật",
    width: 180,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("DD/MM/YYYY"),
  },
  {
    field: "ten_nguoicn",
    headerName: "Người cập nhật",
    width: 250,
    headerAlign: "center",
  },
];
export default function ThongkephuongtienGT() {
  const [pageSize, setPageSize] = React.useState(50);
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [baocao, setBaocao] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const getbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/BaoCao/getslthphuongtiendonvithangqd342025?thang=" +
      thang +
      "&donvi_id=" +
      0 +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setBaocao(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  React.useEffect(() => {
    getbaocao();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => setThangnam(newValue)}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="primary"
            variant="contained"
            style={{ height: 32 }}
            onClick={getbaocao}
          >
            Xem
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 10 }}>
        <div style={{ height: 500, width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={baocao}
            columns={bccolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
    </GridContainer>
  );
}
